module.exports = __webpack_public_path__ + "img/1547207273.ce9cc900.jpg";